/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccounttDeleteMutation($vendorAccounttId: ID!) {
  VendorAccounttDelete(vendorAccounttId: $vendorAccounttId) {
    id
    message
    status
  }
}
`
